var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"api-key-user-table-cell"},[_c('div',{staticClass:"api-key-user-table-cell__name"},[_vm._v(" "+_vm._s(_vm.formattedName)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }